import { Icon } from '@chakra-ui/icons';

function ErrorCircleIcon(props) {
  return (
    <Icon viewBox="0 0 16 17" {...props}>
      <path
        d="M8.00004 1.8335C4.32404 1.8335 1.33337 4.82416 1.33337 8.50016C1.33337 12.1762 4.32404 15.1668 8.00004 15.1668C11.676 15.1668 14.6667 12.1762 14.6667 8.50016C14.6667 4.82416 11.676 1.8335 8.00004 1.8335ZM10.8047 10.3622L9.86204 11.3048L8.00004 9.44283L6.13804 11.3048L5.19537 10.3622L7.05737 8.50016L5.19537 6.63816L6.13804 5.6955L8.00004 7.5575L9.86204 5.6955L10.8047 6.63816L8.94271 8.50016L10.8047 10.3622Z"
        fill="#E53E3E"
      />
    </Icon>
  );
}

export default ErrorCircleIcon;
